import React from 'react';


class Line extends React.Component {
  render() {
    return (
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    );
  }
}


export default Line;